export const getAppColor = (name: string): string => {
  const gradientMap: Record<string, string> = {
    'Augmented Exposure': 'linear-gradient(90deg, #846D4B 0%, #A68754 100%)',
    'Augmented Performance': 'linear-gradient(90deg, #F27433 0%, #FD8D1E 100%)',
    'Augmented Wellbeing': 'linear-gradient(90deg, #689A59 0%, #8FB224 100%)',
    'Augmented Situations': 'linear-gradient(90deg, #746F6D 0%, #A9A5A4 100%)',
    'Augmented Corporate': 'linear-gradient(90deg, #01A5C1 0%, #02B3AD 100%)',
    'Augmented Psychology': 'linear-gradient(90deg, #027AC3 0%, #00ACED 100%)',
    'Augmented Mentalization':
      'linear-gradient(90deg, #3C5A8C 0%, #3278A0 100%)',
  };

  return gradientMap[name] || 'black';
};
